// © 2015-2021 WDNA - All Rights Reserved
import { UserDO } from 'wdna-components/lib/types.new';

export const AUTH_USER: string = 'AUTH_USER';
export const REMOVE_USER: string = 'REMOVE_USER';

export type RxAction = {
  type: string;
  user?: UserDO;
}

/**
 * Performs an authentication user action
 *
 * @param user object to authenticate
 * @returns action object
 */
export function authUser(user: UserDO): RxAction {
  return {
    type: AUTH_USER,
    user,
  };
}

/**
 * Performs a remove user action
 *
 * @returns action object
 */
export function removeUser(): RxAction {
  return {
    type: REMOVE_USER,
  };
}
